function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var svg = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDcuNXYtMkg3di01SDV2NUgwdjJoNXY1aDJ2LTVoNXoiIGZpbGw9IiM3MDY2RTAiLz48L3N2Zz4=";
import { SvgIcon } from "./SvgIcon";
export var IconPlus = function IconPlus(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    src: svg,
    testId: "icon-plus"
  }));
};